import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from '@usas/ui-web/wrappers/ReactRouterDom';

import validate from './ClubRecognitionFilterValidation';

import { navLinks } from '../../../UseNavLinks';

import useClubRecognitionData from '../../../state/workflow/clubRecognition/UseClubRecognitionData';

import useProgramLevelData from '@usas/ui-web/state/programLevel/UseProgramLevelData';
import useEnvironmentVariableData from '@usas/ui-web/state/environmentVariable/UseEnvironmentVariableData';

import useForm from '@usas/ui-web/utils/UseForm';
import Constants from '@usas/ui-web/utils/Constants';

const useClubRecognition = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { clubRecognitionState, getClubRecognitionRequest } = useClubRecognitionData();
  const { clearProgramLevelObjData } = useProgramLevelData();
  const { USAS_ORGANIZATION_ID } = useEnvironmentVariableData();
  const { formState, errorState, onValueTextPairChanged, handleSubmit, setFormState, setErrors
  } = useForm(getInitialFormState, submitFormCallback, validate);
  const [filteredArrayData, setFilteredArrayData] = useState([]);

  const onEdit = (e, programLevel) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    navigate(navLinks.CLUB_RECOGNITION_PROGRAM_LEVEL, { state: { programLevel } });
  };

  const onClearFilterClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setFormState(getInitialFormState);
    setErrors({});
    setFilteredArrayData([...clubRecognitionState.arrayData]);
  };

  useEffect(() => {
    clearProgramLevelObjData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (clubRecognitionState.isArrayLoaded !== true) {
      if (location.state && location.state?.isRevisit === true) {
        getClubRecognitionRequest(true);
      }
      else {
        getClubRecognitionRequest(false);
      }
    } else {
      if (formState.orgUnitId) {
        const newFilteredArray = clubRecognitionState.arrayData.filter((club) => club.clubOrgUnitId === formState.orgUnitId) || [];

        setFilteredArrayData(newFilteredArray);
      } else {
        setFilteredArrayData([...clubRecognitionState.arrayData]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clubRecognitionState]);

  function submitFormCallback() {
    const newFilteredArray = clubRecognitionState.arrayData.filter((club) => club.clubOrgUnitId === formState.orgUnitId) || [];

    setFilteredArrayData(newFilteredArray);
  };

  function getInitialFormState() {
    return {
      orgUnitId: '',
      orgUnitName: '',
      orgUnitLabel: Constants.USAS_ORG_UNIT_LABEL_LSC
    };
  };

  return {
    location,
    isArrayLoading: clubRecognitionState.isArrayLoading,
    filteredArrayData,
    formState,
    errorState,
    USAS_ORGANIZATION_ID,
    onEdit,
    onValueTextPairChanged,
    handleSubmit,
    onClearFilterClicked
  };
};

export default useClubRecognition;